module.exports = __webpack_public_path__ + "img/logo-stf-desktop.6732e8f8.svg";